import { Modal } from "components";
import React from "react";
import ChooseTemplateModal from "./ChooseTemplateModal";
import { ButtonTertiary } from "components/Atoms/Button";

interface Props {
  onTemplateSelected: (template: server.dto.MessageTemplate, language: server.dto.Languages) => void
  type: server.dto.MessageTemplateTypes
  buttonLabel: string
}

const ChooseTemplateButton = (props: Props) => {
  const [displayTemplates, setDisplayTemplates] = React.useState(false);

  const onTemplateSelected = (template: server.dto.MessageTemplate, language: server.dto.Languages) => {
    setDisplayTemplates(false);
    props.onTemplateSelected(template, language);
  };

  return <>
    <ButtonTertiary label={props.buttonLabel} onClick={() => { setDisplayTemplates(true); }} />

    <Modal
      isOpen={displayTemplates}
      handleClose={() => { setDisplayTemplates(false); }}
      title={RESX.Template.SelectTemplate}
      size="small"
      height={600}
    >
      <ChooseTemplateModal
        type={props.type}
        onTemplateSelected={onTemplateSelected}
        canConfigureTemplates={site.permissions.canConfigureTemplates}
      />
    </Modal>
  </>;
};

export default ChooseTemplateButton;